import React from 'react';
import { format, parseISO } from 'date-fns';
import { CalendarCheck, Mail, Video } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function BookingSuccess({ selectedSlot, formData }) {
  const t = selectedSlot ? parseISO(selectedSlot.time) : null;

  return (
    <div className="flex flex-col items-center gap-5 px-2 py-6 text-center animate-fade-in">
      <div className="flex size-16 items-center justify-center rounded-full bg-success-soft">
        <CalendarCheck className="size-7 text-success" />
      </div>

      <div className="space-y-1.5">
        <h2 className="text-xl font-semibold tracking-tight">You're booked in 🎉</h2>
        <p className="max-w-sm text-sm text-muted-foreground">
          We've sent the calendar invite + Google Meet link to{' '}
          <span className="font-medium text-foreground">{formData.email}</span>.
        </p>
      </div>

      {t && (
        <div className="w-full max-w-sm rounded-lg border bg-card p-4 text-left shadow-soft">
          <div className="flex items-start gap-3">
            <CalendarCheck className="mt-0.5 size-4 shrink-0 text-primary" />
            <div className="min-w-0">
              <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                Your discovery call
              </p>
              <p className="mt-0.5 text-sm font-semibold">
                {format(t, 'EEEE, MMMM d')}
              </p>
              <p className="text-sm tabular text-muted-foreground">
                {format(t, 'h:mm a')} · 30 minutes
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col items-center gap-2 text-xs text-muted-foreground">
        <p className="flex items-center gap-1.5">
          <Video className="size-3.5" />
          Google Meet link in your inbox
        </p>
        <p className="flex items-center gap-1.5">
          <Mail className="size-3.5" />
          Reminder 30 minutes before
        </p>
      </div>

      <Button
        variant="link"
        size="sm"
        onClick={() => window.location.reload()}
        className="text-xs text-muted-foreground"
      >
        Book another call →
      </Button>
    </div>
  );
}
